/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Kontakte_Knupfen26Inputs */

const en__field_enum_csjensblank_kontakte_knupfen26 = /** @type {(inputs: _Field_Enum_Csjensblank_Kontakte_Knupfen26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know other People`)
};

const de__field_enum_csjensblank_kontakte_knupfen26 = /** @type {(inputs: _Field_Enum_Csjensblank_Kontakte_Knupfen26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakte knüpfen`)
};

/**
* | output |
* | --- |
* | "Get to know other People" |
*
* @param {_Field_Enum_Csjensblank_Kontakte_Knupfen26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_kontakte_knupfen26 = /** @type {((inputs?: _Field_Enum_Csjensblank_Kontakte_Knupfen26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Kontakte_Knupfen26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_kontakte_knupfen26(inputs)
	return de__field_enum_csjensblank_kontakte_knupfen26(inputs)
});
export { _field_enum_csjensblank_kontakte_knupfen26 as "_field_enum_CSJENSBLANK_KONTAKTE_KNUPFEN" }